module.exports = __webpack_public_path__ + "static/media/default_user.dc177a71.svg";